/**
 * Database files a move left behind on this device — an encrypted org's copy
 * once the org is decrypted, deleted, left, or taken down to this device. They
 * are deleted at the next start, before anything opens the pool (main.js):
 * while the app runs, the file it has open holds the pool.
 */
const KEY = 'okane.dropFiles'

export function filesToDrop() {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '[]')
  } catch {
    return []
  }
}
export function dropLater(file) {
  try {
    localStorage.setItem(KEY, JSON.stringify([...new Set([...filesToDrop(), file])]))
  } catch {
    // Left on the device: it is this device's own copy, and nothing opens it.
  }
}
export function dropped(file) {
  try {
    localStorage.setItem(KEY, JSON.stringify(filesToDrop().filter((f) => f !== file)))
  } catch {
    // nothing kept
  }
}
